import React from "react"
import { graphql } from "gatsby"
import Layout from "../layouts/default"
import SEO from "../utils/seo"
import Taxonomy from "@slice/taxonomy/taxonomy"
import Chatbot from "@slice/chatbot"

const Scene = ({ data, ...props }) => {
  return (
    <Layout isBusinessPage={false}>
      <SEO title={data?.term?.title} />
      <Taxonomy
        title={data?.term?.title}
        otherTerms={data?.otherTerms?.nodes}
        kbItems={data?.kbItems?.nodes}
      />
      <Chatbot />
    </Layout>
  )
}

export default Scene

export const query = graphql`
  query TaxonomyTerm($tid: Int!) {
    term: taxonomyTermKnowledgeBaseCategories(
      drupal_internal__tid: { eq: $tid }
    ) {
      tid: drupal_internal__tid
      title: name
      path {
        alias
      }
    }

    otherTerms: allTaxonomyTermKnowledgeBaseCategories(
      filter: { drupal_internal__tid: { ne: $tid } }
    ) {
      nodes {
        tid: drupal_internal__tid
        title: name
        path {
          alias
        }
      }
    }

    kbItems: allNodeKnowledgeBaseItem(
      filter: {
        field_hidden: { eq: false }
        relationships: {
          field_category: {
            drupal_internal__tid: { eq: $tid }
            path: { alias: { ne: null } }
          }
        }
      }
      sort: { field_last_updated: DESC }
    ) {
      nodes {
        nid: drupal_internal__nid
        title
        changed: field_last_updated
        relationships {
          category: field_category {
            tid: drupal_internal__tid
          }
        }
        redirect_link {
          uri_alias
        }
        path {
          alias
        }
      }
    }
  }
`
